<svg
  width="112"
  height="112"
  viewBox="0 0 112 112"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M55.9985 0.849609C57.9858 0.849609 59.6943 2.2582 60.0732 4.20906L64.174 25.3233C66.3856 36.7099 75.289 45.6134 86.6756 47.8249L107.79 51.9258C109.741 52.3046 111.149 54.0131 111.149 56.0005C111.149 57.9878 109.741 59.6963 107.79 60.0751L86.6756 64.176C75.289 66.3875 66.3856 75.291 64.174 86.6776L60.0732 107.792C59.6943 109.743 57.9858 111.151 55.9985 111.151C54.0112 111.151 52.3027 109.743 51.9238 107.792L47.8229 86.6776C45.6114 75.291 36.708 66.3875 25.3214 64.176L4.2071 60.0751C2.25625 59.6963 0.847656 57.9878 0.847656 56.0005C0.847656 54.0131 2.25625 52.3046 4.2071 51.9258L25.3214 47.8249C36.708 45.6134 45.6114 36.7099 47.8229 25.3233L51.9238 4.20906C52.3027 2.2582 54.0112 0.849609 55.9985 0.849609Z"
    fill="currentColor"
  />
</svg>
